<template>
	<div class="personnelList ">
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="disBetween searchLeft">
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.search" placeholder="请输入人员名称">
						</el-input>
					</div>
					<!-- <div class="myinputBox">
							<el-select clearable v-model="searchObj.repairUserType" slot="prepend"
								placeholder="请选择人员级别">
								<el-option v-for="(item,inx) in personList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div> -->
					<div class="myinputBox myinputBox2">
						<el-cascader ref="cascader1" :props="props" :options="areaList" v-model="areaValue" clearable
							@change="handleChange($event,1)" placeholder="请选择管辖地区"></el-cascader>
						<!-- <el-cascader clearable ref="cascader1"
								:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}"
								v-model="areaValue" placeholder="请选择管辖地区" :options="areaList"
								@change="handleChange($event,1)">
							</el-cascader> -->
					</div>
					<el-button type="success" @click="toSearch">查询</el-button>
				</div>
				<el-button type="success" @click="exportData">导出</el-button>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="repairUserId" label="人员编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="repairUserName" label="人员名称">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="repairUserPhone" label="联系方式">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="checkFlag" label="审核状态">
							<template slot-scope="scope">
								<span>{{scope.row.checkFlag==1?"审核中":scope.row.checkFlag==2?"审核通过":'审核不通过'}}</span>
							</template>
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="checkFlag" label="权限">
								<template slot-scope="scope">
									<span>{{scope.row.checkFlag==1?"审核中":scope.row.checkFlag==2?"审核通过":'审核不通过'}}</span>
								</template>
							</el-table-column> -->
						<el-table-column show-overflow-tooltip prop="checkContent" label="审核内容">
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="manageProvinceNo" label="管辖地区">
								<template slot-scope="scope">
									<span>{{scope.row.manageProvinceNo}}</span>
									<span>{{scope.row.manageCityNo}}</span>
									<span>{{scope.row.manageAreaNo}}</span>
								</template>
							</el-table-column> -->
						<el-table-column show-overflow-tooltip prop="repairUserStatus" label="状态">
							<template slot-scope="scope">
								<span>{{scope.row.repairUserStatus==2?"停工":scope.row.repairUserStatus==1?"正常":''}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<el-button v-if="scope.row.checkFlag==1" type="text" size="small"
									@click="itemClick(scope.row,1)">审核</el-button>
								<el-button v-if="scope.row.checkFlag!=1" type="text" size="small"
									@click="itemClick(scope.row,1)">查看</el-button>
								<el-button v-if="scope.row.checkFlag!=1" type="text" size="small"
									@click="itemClick(scope.row,3)">权限修改</el-button>
								<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :visible.sync="dialogVisible" width="80%">
			<div class="dialogBox3">
				<div class="titleBox">运维人员信息</div>
				<div class="contBox">
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">人员名称:</span>
							<span class="valueBox">{{creatObj.repairUserName}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">人员编号:</span>
							<span class="valueBox">{{creatObj.repairUserId}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox">
							<span class="nameBox">联系方式:</span>
							<span class="valueBox">{{creatObj.repairUserPhone}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">身份证号:</span>
							<span class="valueBox">{{creatObj.certificateId}}</span>
						</div>
					</div>
					<!-- <div class="itemBox ">
						<span>人员状态：{{creatObj.repairUserStatus==1?"正常":creatObj.repairUserStatus==2?"停工":""}}</span>
					</div> -->


					<div class="itemBox  disStart">
						<div class="imgBox"><span>身份证正面照:</span>
							<div class=" disStart">
								<el-image class="img" error="暂无图片" :src="$basImgUrl+creatObj.certificateFrontUrl"
									:preview-src-list="[$basImgUrl+creatObj.certificateFrontUrl]">
								</el-image>
							</div>
						</div>
						<div class="imgBox"><span>身份证反面照:</span>
							<div class=" disStart">
								<el-image class="img" :src="$basImgUrl+creatObj.certificateBackUrl"
									:preview-src-list="[$basImgUrl+creatObj.certificateBackUrl]">
								</el-image>
							</div>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="imgBox"><span>电工证:</span>
							<div class=" disStart">
								<el-image class="img2" :src="$basImgUrl+creatObj.electricianCertificateUrl"
									:preview-src-list="[$basImgUrl+creatObj.electricianCertificateUrl]">
								</el-image>
							</div>
						</div>
					</div>
					<div class="itemBox  ">
						<div class="elBox elBox2">
							<span class="nameBox">管辖地区:</span>
							<span class="valueBox">{{getStr(creatObj.communityIdList)}}</span>
						</div>
					</div>

					<div class="itemBox  ">
						<div class="elBox elBox2">
							<span class="nameBox">具体地址:</span>
							<span class="valueBox">{{creatObj.provinceName}}{{creatObj.cityName}}{{creatObj.areaName}}
								{{creatObj.address}}</span>
						</div>
					</div>
					<div class="itemBox  ">
						<div class="elBox elBox2">
							<span class="nameBox">申请权限:</span>
							<span class="valueBox">
								<span class="flag">
									{{creatObj.overhaulFlag==2?'故障检修权限':""}}
								</span>
								<span class="flag">
									{{creatObj.installFlag==2?'设备安装权限':""}}{{creatObj.installFag==2?'设备安装权限':""}}
								</span>
								<span class="flag">
									{{creatObj.initializeFlag==2?'初始化权限':""}}
								</span>
								<span class="flag">
									{{creatObj.bindFlag==2?'解绑设备权限':""}}
								</span>
								<span class="flag">
									{{creatObj.rechargeCardFlag==2?'转卡权限':""}}
								</span>
								<span class="flag">
									{{creatObj.communityFlag==2?'设备查看':""}}
								</span>
								<span class="flag">
									{{creatObj.expressFlag==2?'快递物流':""}}
								</span>
							</span>
						</div>
					</div>
					<div class="itemBox" v-if="creatObj.communityFlag==2">
						<div class="elBox elBox2">
							<span class="nameBox">负责社区:</span>
							<div class="communityBox" >
								<div v-for="(item,inx) in creatObj.communityCenterIdList">
									<span>
										{{item.communityName}}
									</span>
									<span v-if="inx<creatObj.communityCenterIdList.length-1">
										,
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="titleBox">审核信息</div>
				<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm"
					v-if="creatObj.checkFlag==1">
					<div class="diaItem diaItem2">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="审核结果:" prop="check">
								<div class="myinputBox4">
									<el-radio-group v-model="creatObj.check">
										<el-radio :label="2">通过</el-radio>
										<el-radio :label="3">不通过</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem diaItem2" v-if="creatObj.check==3">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="审核内容:" prop="checkContent">
								<div class="myinputBox4">
									<el-input clearable v-model="creatObj.checkContent" placeholder="请输入审核内容">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div class="contBox" v-else>
					<div class="itemBox  disStart">
						<div class="elBox elBox2">
							<span class="nameBox">审核结果:</span>
							<span class="valueBox">{{creatObj.checkFlag==2?"通过":creatObj.checkFlag==3?"不通过":""}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox elBox2">
							<span class="nameBox">审核内容:</span>
							<span class="valueBox">{{creatObj.checkContent}}</span>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="diabtnBox" v-if="creatObj.checkFlag==1">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="toSave('ruleForm1')">确定</el-button>
			</div>
			<div slot="footer" class="diabtnBox" v-else>
				<el-button type="primary" @click="dialogVisible = false">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="权限" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow"
			width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item label="权限:" prop="flag">
								<el-checkbox-group v-model="creatObj.flag">
									<el-checkbox label="1">故障检修权限</el-checkbox>
									<el-checkbox label="2">设备安装权限</el-checkbox>
									<el-checkbox label="3">初始化权限</el-checkbox>
									<el-checkbox label="4">解绑设备权限</el-checkbox>
									<el-checkbox label="5">转卡权限</el-checkbox>
									<el-checkbox label="6">设备查看</el-checkbox>
									<el-checkbox label="7">快递物流</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</div>
					</div>
					<div class="communityBox" v-if="creatObj.flag.includes('6')">
						<span class="choice" @click="choiceCommunity">选择社区</span>
						<div v-for="(item,inx) in creatObj.communityCenterIdList" class="itemBox">
							<span>
								{{item.communityName}}
							</span>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="选择社区" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogDispose2"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="disposeBox disBetween">
					<div class="disposeLeft">
						<div class="choiceBox">选择地区</div>
						<div class="moduleList">
							<el-tree highlight-current :props="props2" :load="loadNode2" lazy @node-click="nodeClick2">
							</el-tree>
						</div>
					</div>
					<div class="linBox"></div>
					<div class="disposeRight">
						<div class="choiceBox">社区名称</div>
						<div class="moduleList">
							<div v-for="(item,inx) in menuList2" :key="inx" class="itemBox disStart">
								<span class="titleBox">{{item.communityName}}</span>
								<el-checkbox v-model="item.checkFlag" @change="menuClick2($event,item,inx)">
								</el-checkbox>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button @click="dialogDispose2 = false">取 消</el-button>
					<el-button type="primary" @click="savedialogDispose2">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: "personnelList",
		components: {},
		data() {
			let that = this;
			return {
				active: 0,
				props: {
					value: 'areaCode',
					label: 'areaName',
					lazy: true,
					lazyLoad(node, resolve) {
						const {
							level
						} = node;
						that.provinceFn(node.value || "").then((res) => {
							if (res.returnCode == 200) {
								var data = [];
								if (res.obj.type != 2) {
									data = res.obj.list
								} else {
									for (let k of res.obj.list) {
										data.push({
											areaCode: k.communityId,
											areaName: k.communityName
										})
									}
								}
								data.map(item => {
									item.leaf = res.obj.type == 2 //leaf如果是true就结束了，意味着没有下一级
									return item;
								})
								resolve(data);
							} else {
								resolve([]);
							}
						})
					}
				},
				props2: {
					label: 'areaName',
					value: "areaCode",
					isLeaf: 'leaf'
				},
				dialogDispose2: false,
				saveArr2: [],
				menuList2: [],
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {
					repairUserName: "", //人员名称
					repairUserId: "", //人员工号
					repairUserPhone: "", //联系电话
					repairUserType: "", //人员级别
					manageProvinceNo: "", //管辖省
					manageCityNo: "", //管辖市
					manageAreaNo: "", //管辖区
					repairUserStatus: "", //人员状态 1正常 2停工
					provinceNo: "", //家庭住址省
					cityNo: "", //运维人员
					areaNo: "", //家庭住址区
					address: "", //家庭住址详细地址
					communityIdList: [],
					communityCenterIdList: [],
					flag: []
				},
				dialogVisible: false,
				visibleShow: false,
				NOfalse: false,
				dialogTitle: "新增运维人员",
				statusList: [{
						text: "通过",
						value: 2
					},
					{
						text: "不通过",
						value: 3
					}
				],
				tableData: [],
				communityList: [],
				personList: [{
						text: "初级",
						value: 1
					},
					{
						text: "中级",
						value: 2
					},
					{
						text: "高级",
						value: 3
					}
				],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					// repairUserNo: "", //人员工号
					manageProvinceNo: "", //管辖省
					manageCityNo: "", //管辖市
					manageAreaNo: "", //管辖区
					search: "", //查询
					checkFlag: "", //1审核中 2审核通过 3审核不通过
					communityId: "" //社区id
				},
				options: [],
				areaList: [],
				areaValue: "",
				rules: {
					check: [{
						required: true,
						message: '请选择审核结果',
						trigger: 'change'
					}],
					checkContent: [{
						required: true,
						message: '请输入审核内容',
						trigger: 'blur'
					}],
					flag: [{
						required: true,
						message: '请至少选择一个权限',
						trigger: 'change'
					}],
				},
			}
		},
		created() {},
		mounted() {

			this.$nextTick(() => {
				this.getData()
				// this.getAreaList()
				// if (!(localStorage.getItem("areaList"))) {
				// 	this.getAreaList()
				// } else {
				// 	this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				// }
			})
		},
		methods: {
			choiceCommunity() {
				this.saveArr2 = JSON.parse(JSON.stringify(this.creatObj.communityCenterIdList))
				for (let j of this.menuList2) {
					this.$set(j, "checkFlag", false)
					for (let k of this.creatObj.communityCenterIdList) {
						if (j.communityId == k.communityId) {
							this.$set(j, "checkFlag", true)
						}
					}
				}
				this.$nextTick(()=>{
					this.dialogDispose2 = true
				})
			},
			savedialogDispose2() {
				this.dialogDispose2 = false
				this.$set(this.creatObj, "communityCenterIdList", this.saveArr2)
				this.$set(this, "saveArr2", [])
			},
			menuClick2(e, item, inx, ) {
				this.$nextTick(() => {
					if (e == false) {
						let index = this.saveArr2.findIndex((res) => {
							return res.communityId == item.communityId
						})
						if (index != -1) {
							this.saveArr2.splice(index, 1)
						}
					} else {
						this.saveArr2.push({
							communityId: item.communityId,
							communityName: item.communityName,
						})
					}
					this.$set(this.creatObj, "communityCenterIdList", this.saveArr2)

				})
			},
			nodeClick2(n, m, l) {
				if (n.leaf) {
					this.saveArr2 = JSON.parse(JSON.stringify(this.creatObj.communityCenterIdList))
					this.$api.listAreaInfoAndCommunity({
						parentAreaCode: n.areaCode
					}).then((res) => {
						console.log(res)
						for (let j of res.obj.list) {
							this.$set(j, "checkFlag", false)
							for (let k of this.creatObj.communityCenterIdList) {
								if (j.communityId == k.communityId) {
									console.log(j)
									this.$set(j, "checkFlag", true)
								}
							}
						}

						this.$set(this, "menuList2", res.obj.list)
					})
				}
			},
			loadNode2(node, resolve) {
				console.log(222222222222)
				let id = ""
				if (node.data) {
					// if()
					id = node.data.areaCode
				}

				this.$api.listAreaInfoAndCommunity({
					parentAreaCode: id
				}).then((res) => {
					if (res.returnCode == 200) {
						if (res.obj.type == 1) {
							for (let k of res.obj.list) {
								if (node.level == 1) {
									if (node.data.areaName == "北京市" || node.data.areaName ==
										"天津市" ||
										node.data.areaName == "上海市" || node.data.areaName == "重庆市" || node
										.data
										.areaName == "香港特别行政区" || node.data
										.areaName == "澳门特别行政区") {
										k.leaf = true
									}
								} else if (node.level == 2) {
									k.leaf = true
								}
							}
							return resolve(res.obj.list)
						}
					}
				})
			},
			changeList(n) {
				this.active = n
				// this.searchObj.pageNo = 1
				// this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					// this.getData(n)
				})

			},
			exportData() {
				let obj = {
					manageProvinceNo: this.searchObj.manageProvinceNo,
					manageCityNo: this.searchObj.manageCityNo,
					manageAreaNo: this.searchObj.manageAreaNo,
					search: this.searchObj.search,
					checkFlag: this.searchObj.checkFlag,
					communityId: this.searchObj.communityId,
				}
				this.$api.exportOrderRepairUser(obj, "运维人员列表").then((res) => {
					if (res.returnCode == 200) {

					}
				})

			},
			provinceFn(id) {
				let data = {
					parentAreaCode: id,
				};
				return this.$api.listAreaInfo(data);
			},
			getStr(arr) {
				let str = ""
				if (arr[0] && arr[0]) {
					for (let k in arr) {
						if (k == arr.length - 1) {
							str += (arr[k].communityName)
						} else {
							str += (arr[k].communityName + ",")
						}
					}
				}
				return str
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == "ruleForm1") {
							let obj = {
								repairUserId: that.creatObj.repairUserId,
								checkFlag: that.creatObj.check,
								checkContent: that.creatObj.check == 3 ? that.creatObj.checkContent : "",
							}
							that.$api.checkOrderRepairUser(obj).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '审核成功!'
									});
									setTimeout(() => {
										that.getData()
									}, 500)
									this.dialogVisible = false
								}
							})
						} else {
							if (that.creatObj.flag.includes("1")) {
								that.creatObj.overhaulFlag = 2
							} else {
								that.creatObj.overhaulFlag = 1
							}
							if (that.creatObj.flag.includes("2")) {
								that.creatObj.installFlag = 2
							} else {
								that.creatObj.installFlag = 1
							}
							if (that.creatObj.flag.includes("3")) {
								that.creatObj.initializeFlag = 2
							} else {
								that.creatObj.initializeFlag = 1
							}
							if (that.creatObj.flag.includes("4")) {
								that.creatObj.bindFlag = 2
							} else {
								that.creatObj.bindFlag = 1
							}
							if (that.creatObj.flag.includes("5")) {
								that.creatObj.rechargeCardFlag = 2
							} else {
								that.creatObj.rechargeCardFlag = 1
							}
							if (that.creatObj.flag.includes("6")) {
								let arr = []
								for (let k of that.creatObj.communityCenterIdList) {
									arr.push(k.communityId)
								}
								if (arr.length > 0) {
									that.creatObj.communityFlag = 2
									this.$set(this.creatObj, "communityCenterIdList", arr)
								} else {
									that.$message({
										type: 'warning',
										message: '请至少选择一个社区!'
									});
									return false
								}
							} else {
								that.creatObj.communityFlag = 1
							}
							if (that.creatObj.flag.includes("7")) {
								that.creatObj.expressFlag = 2
							} else {
								that.creatObj.expressFlag = 1
							}
							// let obj = {
							// 	repairUserId: that.creatObj.repairUserId,
							// 	repairUserName: that.creatObj.repairUserName,
							// 	repairUserNo: that.creatObj.repairUserNo,
							// 	repairUserPhone: that.creatObj.repairUserPhone,
							// 	repairUserType: that.creatObj.repairUserType,
							// 	manageProvinceNo: that.creatObj.manageProvinceNo,
							// 	manageCityNo: that.creatObj.manageCityNo,
							// 	manageAreaNo: that.creatObj.manageAreaNo,
							// 	repairUserStatus: that.creatObj.repairUserStatus,
							// 	cityNo: that.creatObj.cityNo,
							// 	areaNo: that.creatObj.areaNo,
							// 	address: that.creatObj.address,
							// 	overhaulFlag: that.creatObj.overhaulFlag,
							// 	installFlag: that.creatObj.installFlag,
							// 	initializeFlag: that.creatObj.initializeFlag,
							// 	electricianCertificateUrl: that.creatObj.electricianCertificateUrl,
							// 	electricianCertificatePath: that.creatObj.electricianCertificatePath,
							// }
							console.log(that.creatObj)
							that.$api.updateOrderRepairUser(that.creatObj).then((res) => {
								if (res.returnCode == 200) {
									that.saveArr2 = []
									that.$message({
										type: 'success',
										message: '修改成功!'
									});
									setTimeout(() => {
										that.getData()
									}, 500)
									this.visibleShow = false
								}
							})
						}

					} else {
						return false;
					}
				});

			},
			// 审核
			itemClick(item, n) {
				let that = this
				if (n == 1) {
					this.dialogTitle = "运维人员信息"
					this.$api.selectOrderRepairUser({
						repairUserId: item.repairUserId
					}).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "creatObj", res.obj)
							this.$set(this.creatObj, "flag", [])
							this.dialogVisible = true
							this.$nextTick(() => {
								this.$refs.ruleForm1.clearValidate()
							})
						}
					})

				} else if (n == 3) {
					this.dialogTitle = "运维人员信息"
					this.$api.selectOrderRepairUser({
						repairUserId: item.repairUserId
					}).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "creatObj", res.obj)
							this.$set(this.creatObj, "flag", [])
							if (res.obj.overhaulFlag == 2) {
								this.creatObj.flag.push("1")
							}
							if (res.obj.installFlag == 2 || res.obj.installFag == 2) {
								this.creatObj.flag.push("2")
							}
							if (res.obj.initializeFlag == 2) {
								this.creatObj.flag.push("3")
							}
							if (res.obj.bindFlag == 2) {
								this.creatObj.flag.push("4")
							}
							if (res.obj.rechargeCardFlag == 2) {
								this.creatObj.flag.push("5")
							}
							if (res.obj.communityFlag == 2) {
								this.creatObj.flag.push("6")
							}
							if (res.obj.expressFlag == 2) {
								this.creatObj.flag.push("7")
							}
							console.log(this.creatObj)
							this.visibleShow = true
							this.$nextTick(() => {
								this.$refs.ruleForm4.clearValidate()
							})
						}
					})
				} else if (n == 5) {
					this.dialogTitle = "新增运维人员"

					this.$set(this, "creatObj", {
						repairUserName: "", //人员名称
						repairUserId: "", //人员工号
						repairUserPhone: "", //联系电话
						repairUserType: "", //人员级别
						manageProvinceNo: "", //管辖省
						manageCityNo: "", //管辖市
						manageAreaNo: "", //管辖区
						repairUserStatus: "", //人员状态 1正常 2停工
						provinceNo: "", //家庭住址省
						cityNo: "", //运维人员
						areaNo: "", //家庭住址区
						address: "", //家庭住址详细地址
						areaValue1: [],
						areaValue2: [],

					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
					})
				} else if (n == 2) {
					this.$confirm('是否确认删除该运维人员?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteOrderRepairUser({
							repairUserId: item.repairUserId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
							} else {
								that.$message({
									message: res.returnMessage || "请求异常",
									type: 'error'
								});
							}
						})

					}).catch(() => {

					});
				}
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAreaInfo({
					"parentAreaCode": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj.list)
						// localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.getData()
			},
			getData(n) {
				this.loading = true
				console.log(this.searchObj,88888888)
				this.$api.listOrderRepairUser(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData({})
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()


				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "communityId", nodesInfo[0].value || "")
					// this.$set(this.searchObj, "manageProvinceNo", nodesInfo[0].path[0] || "")
					// this.$set(this.searchObj, "manageCityNo", nodesInfo[0].path[1] || "")
					// this.$set(this.searchObj, "manageAreaNo", nodesInfo[0].path[2] || "")
				} else {
					this.$set(this.searchObj, "communityId", "")
					// this.$set(this.searchObj, "manageProvinceNo", "")
					// this.$set(this.searchObj, "manageAreaNo", "")
					// this.$set(this.searchObj, "manageCityNo", "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./personnelList.scss";
</style>